import { use_slice_generation } from '@/hooks/store/use_slices';
import { G_LAYOUT__image_edit_base } from '../_base/G_LAYOUT__image_edit_base';
import { GRID2D__images_select } from './GRID2D__images_select';

export function G_LAYOUT__image_replace() {
  const { generation_current } = use_slice_generation(['generation_current']);

  /*
   * HTML
   */

  if (generation_current.is_stub()) return null;

  return (
    <G_LAYOUT__image_edit_base>
      <GRID2D__images_select />
    </G_LAYOUT__image_edit_base>
  );
}
